import { getDetails } from '$lib/shared/notifications';
import { writable, type Writable } from 'svelte/store';

function createNotificationStore(): Writable<NotificationsResult> {
	const { set, update, subscribe }: Writable<NotificationsResult> = writable({
		total: 0,
		notifications: [],
	});

	return {
		set: async (value) => {
			const promises = value.notifications.map(async (notification) => {
				if (
					notification.details.type === 'NEWER_SUBMISSION' ||
					notification.details.type === 'RECEIVED_APPROVAL'
				) {
					const details = await getDetails(
						notification.details.objectId,
						notification.details.submissionId
					);
					return { ...notification, ...details };
				}
				return notification;
			});

			const notifications = await Promise.all(promises);

			set({ ...value, notifications });
		},
		update,
		subscribe,
	};
}
export const notifications: Writable<NotificationsResult> = createNotificationStore();
